module.exports = __webpack_public_path__ + "img/concurrency_vs_parallelism.975a6118.jpg";